import dayjs from 'dayjs';
export const NO_OF_RECORDS_PER_PAGE = 20;
export const qualificationStatusField = 'qualificationStatus';
import addDays from 'date-fns/addDays';
import startOfWeek from 'date-fns/startOfWeek';
import { convertToDayStart, convertToDayEnd } from 'src/utils/utilityMethods';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { isValidTimezoneDayjs } from 'src/utils/timezonesConvertor';
import { convertDateToFormattedString } from 'src/features/Icp/utils';

// Ensure dayjs can handle timezone-aware operations when needed
dayjs.extend(utc);
dayjs.extend(timezone);

export const qualificationStylesHeader = {
  position: 'sticky',
  right: 0,
  zIndex: 3,
};

export const fixedHeader = {
  position: 'sticky',
  left: 0,
  zIndex: 3,
};
export const startDateForWebpagesFilter = '2023-01-01';
export const startDateForFilters = dayjs(
  convertToDayStart(addDays(startOfWeek(new Date(), { weekStartsOn: 0 }), -7)),
).format('YYYY-MM-DD HH:mm:ss');
export const endDateForFilters = dayjs(convertToDayEnd(new Date())).format('YYYY-MM-DD 23:59:59');
export const getLatestStartDateForFilters = () => {
  return dayjs(convertToDayStart(addDays(startOfWeek(new Date(), { weekStartsOn: 0 }), -7))).format(
    'YYYY-MM-DD HH:mm:ss',
  );
};

export const getLatestEndDateForFilters = () => {
  return dayjs(convertToDayEnd(new Date())).format('YYYY-MM-DD 23:59:59');
};
export const startDateForIPDataRecieval = dayjs(getSecondLastDay()).format('YYYY-MM-DD 00:00:01');
export const endDateForIPDataRecieval = dayjs(new Date()).format('YYYY-MM-DD 23:59:59');

function getSecondLastDay(): Date {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 2);
  return currentDate;
}

export const ruleEngine = {
  forTrue: ['Qualified', 'Disqualified', 'Already Exists', 'Unknown'],
  forFalse: ['Qualified', 'Unqualified', 'Already Exists'],
};

// for websiteaccount
export const webAccFilterResponse = {
  Organization: 'Organization',
  Country: 'Country',
  State: 'State',
  City: 'City',
  Industry: 'Industry',
  Revenue: 'Revenue',
  Employee_Count: 'Employee Count',
  Latest_Funding_Stage: 'Latest Funding Stage',
  Total_Funding_Amount: 'Total Funding Amount',
  Qualification: 'Qualification',
  Last_Visited_Date: 'Last Visited Date', // not a response
  Number_of_visits: 'Number of visits',
  Latest_Funding_Amount: 'Latest Funding Amount',
  Latest_Funding_Date: 'Latest Funding Date',
  Pages_Visited: 'Pages visited',
};

export interface WebAccFilterGroupType {
  label: string;
  groups: {
    label: string;
    key: string;
  }[];
}

export const WebAccFilterGroup: WebAccFilterGroupType[] = [
  {
    label: 'Company',
    groups: [{ label: 'Company', key: webAccFilterResponse.Organization }],
  },
  {
    label: 'Country',
    groups: [{ label: 'Country', key: webAccFilterResponse.Country }],
  },
  {
    label: 'State',
    groups: [{ label: 'State', key: webAccFilterResponse.State }],
  },
  {
    label: 'City',
    groups: [{ label: 'City', key: webAccFilterResponse.City }],
  },
  // {
  //   label: 'Location',
  //   groups: [
  //     { label: 'Country', key: webAccFilterResponse.Country },
  //     { label: 'State', key: webAccFilterResponse.State },
  //     { label: 'City', key: webAccFilterResponse.City },
  //   ],
  // },
  {
    label: 'Employee count',
    groups: [{ label: 'Employee count', key: webAccFilterResponse.Employee_Count }],
  },
  {
    label: 'Industry',
    groups: [{ label: 'Industry', key: webAccFilterResponse.Industry }],
  },
  {
    label: 'Revenue ($)',
    groups: [{ label: 'Revenue ($)', key: webAccFilterResponse.Revenue }],
  },
  {
    label: '# visits',
    groups: [{ label: '# visits', key: webAccFilterResponse.Number_of_visits }],
  },
  {
    label: 'Latest Funding Stage',
    groups: [{ label: 'Latest Funding Stage', key: webAccFilterResponse.Latest_Funding_Stage }],
  },
  {
    label: 'Total funding amount',
    groups: [{ label: 'Total funding amount', key: webAccFilterResponse.Total_Funding_Amount }],
  },
  // {
  //   label: 'Funding',
  //   groups: [
  //     { label: 'Date range', key: webAccFilterResponse.dateRange },
  //     { label: '# visits', key: webAccFilterResponse.Number_of_visits },
  //   ],
  // },
  // {
  //   label: 'Website visits',
  //   groups: [
  //     { label: 'Stage', key: webAccFilterResponse.Latest_Funding_Stage },
  //     { label: 'Total funding amount', key: webAccFilterResponse.Total_Funding_Amount },
  //   ],
  // },
  {
    label: 'Qualification',
    groups: [{ label: 'Qualification', key: webAccFilterResponse.Qualification }],
  },
  {
    label: 'Last Visited Date',
    groups: [{ label: 'Last Visited Date', key: webAccFilterResponse.Last_Visited_Date }],
  },
  {
    label: 'Latest Funding Amount',
    groups: [{ label: 'Latest Funding Amount', key: webAccFilterResponse.Latest_Funding_Amount }],
  },
  {
    label: 'Latest Funding Date',
    groups: [{ label: 'Latest Funding Date', key: webAccFilterResponse.Latest_Funding_Date }],
  },
  {
    label: 'Pages visited',
    groups: [{ label: 'Pages visited', key: webAccFilterResponse.Pages_Visited }],
  },
];

export const WebAccFilterArrayData = [
  {
    label: 'Company',
    id: webAccFilterResponse.Organization,
    type: 'multi-select',
  },
  {
    label: 'Country',
    id: webAccFilterResponse.Country,
    type: 'multi-select',
  },
  {
    label: 'State',
    id: webAccFilterResponse.State,
    type: 'multi-select',
  },
  {
    label: 'City',
    id: webAccFilterResponse.City,
    type: 'multi-select',
  },
  {
    label: 'Employee count',
    id: webAccFilterResponse.Employee_Count,
    type: 'min-max',
  },
  {
    label: 'Industry',
    id: webAccFilterResponse.Industry,
    type: 'multi-select',
  },
  {
    label: 'Revenue ($)',
    id: webAccFilterResponse.Revenue,
    type: 'min-max',
  },
  {
    label: '# visits',
    id: webAccFilterResponse.Number_of_visits,
    type: 'min-max',
  },
  {
    label: 'Latest Funding Stage',
    id: webAccFilterResponse.Latest_Funding_Stage,
    type: 'multi-select',
  },
  {
    label: 'Total funding amount',
    id: webAccFilterResponse.Total_Funding_Amount,
    type: 'min-max',
  },
  {
    label: 'Qualification',
    id: webAccFilterResponse.Qualification,
    type: 'multi-select',
  },
  {
    label: 'Date Range',
    id: webAccFilterResponse.Last_Visited_Date,
    type: 'date-range',
  },
  {
    label: 'Latest Funding Amount',
    id: webAccFilterResponse.Latest_Funding_Amount,
    type: 'min-max',
  },
  {
    label: 'Latest Funding Date',
    id: webAccFilterResponse.Latest_Funding_Date,
    type: 'date-range',
  },
  {
    label: 'Pages visited',
    id: webAccFilterResponse.Pages_Visited,
    type: 'multi-select',
  },
];

// for targetProfiles filter
export interface FilterGroupTypeProfiles {
  label: string;
  groups: {
    label: string;
    key: string;
  }[];
}
// contact
export const FilterResponseContact = {
  Organization: 'Organization',
  Country: 'Country',
  State: 'State',
  City: 'City',
  Company_Region: 'Company Region',
  Job_Title: 'Job Title',
  Department: 'Department',
  Designation: 'Designation',
  Industry: 'Industry',
  Revenue: 'Revenue',
  Employee_Count: 'Employee Count',
  Intent_Topics: 'Intent Topics',
  Intent_Score: 'Intent Score',
  List_Name: 'List Name',
  Campaign_Stage: 'Campaign Stage',
  Latest_Funding_Stage: 'Latest Funding Stage',
  Latest_Funding_Amount: 'Latest Funding Amount',
  Latest_Funding_Date: 'Latest Funding Date',
  Total_Funding_Amount: 'Total Funding Amount',
  Job_Openings: 'Job Openings',
  Verified_Email: 'Verified Email',
  Source: 'Source',
  Contact_Owner: 'Contact Owner',
  Last_Visited_Date: 'Last Visited Date',
  Number_of_visits: 'Number of visits',
  Source_File: 'Source File',
};

export const ContactFilterGroup: WebAccFilterGroupType[] = [
  {
    label: 'Company',
    groups: [{ label: 'Company', key: FilterResponseContact.Organization }],
  },
  {
    label: 'Country',
    groups: [{ label: 'Country', key: FilterResponseContact.Country }],
  },
  {
    label: 'State',
    groups: [{ label: 'State', key: FilterResponseContact.State }],
  },
  {
    label: 'City',
    groups: [{ label: 'City', key: FilterResponseContact.City }],
  },
  // {
  //   label: 'Location',
  //   groups: [
  //     { label: 'Country', key: FilterResponseContact.Country },
  //     { label: 'State', key: FilterResponseContact.State },
  //     { label: 'City', key: FilterResponseContact.City },
  //   ],
  // },
  {
    label: 'Company Region',
    groups: [{ label: 'Company Region', key: FilterResponseContact.Company_Region }],
  },
  {
    label: 'Job Title',
    groups: [{ label: 'Job Title', key: FilterResponseContact.Job_Title }],
  },
  {
    label: 'Department',
    groups: [{ label: 'Department', key: FilterResponseContact.Department }],
  },
  {
    label: 'Designation',
    groups: [{ label: 'Designation', key: FilterResponseContact.Designation }],
  },
  {
    label: 'Industry',
    groups: [{ label: 'Industry', key: FilterResponseContact.Industry }],
  },
  {
    label: 'Revenue',
    groups: [{ label: 'Revenue', key: FilterResponseContact.Revenue }],
  },
  {
    label: 'Employee Count',
    groups: [{ label: 'Employee Count', key: FilterResponseContact.Employee_Count }],
  },
  {
    label: 'Intent Topics',
    groups: [{ label: 'Intent Topics', key: FilterResponseContact.Intent_Topics }],
  },
  {
    label: 'Intent Score',
    groups: [{ label: 'Intent Score', key: FilterResponseContact.Intent_Score }],
  },
  {
    label: 'List Name',
    groups: [{ label: 'List Name', key: FilterResponseContact.List_Name }],
  },
  {
    label: 'Campaign Stage',
    groups: [{ label: 'List Name', key: FilterResponseContact.Campaign_Stage }],
  },
  {
    label: 'Latest Funding Stage',
    groups: [{ label: 'Latest Funding Stage', key: FilterResponseContact.Latest_Funding_Stage }],
  },
  {
    label: 'Latest Funding Amount',
    groups: [{ label: 'Latest Funding Amount', key: FilterResponseContact.Latest_Funding_Amount }],
  },
  {
    label: 'Latest Funding Date',
    groups: [{ label: 'Latest Funding Date', key: FilterResponseContact.Latest_Funding_Date }],
  },
  {
    label: 'Total Funding Amount',
    groups: [{ label: 'Total Funding Amount', key: FilterResponseContact.Total_Funding_Amount }],
  },
  {
    label: 'Job Openings',
    groups: [{ label: 'Job Openings', key: FilterResponseContact.Job_Openings }],
  },
  {
    label: 'Verified Email',
    groups: [{ label: 'Verified Email', key: FilterResponseContact.Verified_Email }],
  },
  {
    label: 'Source File',
    groups: [{ label: 'Source File', key: FilterResponseContact.Source_File }],
  },
  {
    label: 'Source',
    groups: [{ label: 'Source', key: FilterResponseContact.Source }],
  },
  {
    label: 'Contact Owner',
    groups: [{ label: 'Contact Owner', key: FilterResponseContact.Contact_Owner }],
  },
  {
    label: 'Number of visits',
    groups: [{ label: 'Number of visits', key: FilterResponseContact.Number_of_visits }],
  },
  {
    label: 'Last Visited Date',
    groups: [{ label: 'Last Visited Date', key: FilterResponseContact.Last_Visited_Date }],
  },
  // {
  //   label: 'Funding',
  //   groups: [
  //     { label: 'Date range', key: webAccFilterResponse.dateRange },
  //     { label: '# visits', key: webAccFilterResponse.Number_of_visits },
  //   ],
  // },
  // {
  //   label: 'Website visits',
  //   groups: [
  //     { label: 'Stage', key: webAccFilterResponse.Latest_Funding_Stage },
  //     { label: 'Total funding amount', key: webAccFilterResponse.Total_Funding_Amount },
  //   ],
  // },
];

export const ContactFilterArrayData = [
  {
    label: 'Company',
    id: FilterResponseContact.Organization,
    type: 'multi-select',
  },
  {
    label: 'Country',
    id: FilterResponseContact.Country,
    type: 'multi-select',
  },
  {
    label: 'State',
    id: FilterResponseContact.State,
    type: 'multi-select',
  },
  {
    label: 'City',
    id: FilterResponseContact.City,
    type: 'multi-select',
  },
  {
    label: 'Company Region',
    id: FilterResponseContact.Company_Region,
    type: 'multi-select',
  },
  {
    label: 'Job Title',
    id: FilterResponseContact.Job_Title,
    type: 'multi-select',
  },
  {
    label: 'Department',
    id: FilterResponseContact.Department,
    type: 'multi-select',
  },
  {
    label: 'Designation',
    id: FilterResponseContact.Designation,
    type: 'multi-select',
  },
  {
    label: 'Industry',
    id: FilterResponseContact.Industry,
    type: 'multi-select',
  },
  {
    label: 'Revenue',
    id: FilterResponseContact.Revenue,
    type: 'min-max',
  },
  {
    label: 'Employee Count',
    id: FilterResponseContact.Employee_Count,
    type: 'min-max',
  },
  {
    label: 'Intent Topics',
    id: FilterResponseContact.Intent_Topics,
    type: 'multi-select',
  },
  {
    label: 'Intent Score',
    id: FilterResponseContact.Intent_Score,
    type: 'intent-score-v2',
  },
  {
    label: 'List Name',
    id: FilterResponseContact.List_Name,
    type: 'multi-select',
  },
  {
    label: 'Campaign Stage',
    id: FilterResponseContact.Campaign_Stage,
    type: 'multi-select',
  },
  {
    label: 'Latest Funding Stage',
    id: FilterResponseContact.Latest_Funding_Stage,
    type: 'multi-select',
  },
  {
    label: 'Latest Funding Amount',
    id: FilterResponseContact.Latest_Funding_Amount,
    type: 'min-max',
  },
  {
    label: 'Latest Funding Date',
    id: FilterResponseContact.Latest_Funding_Date,
    type: 'date-range',
  },
  {
    label: 'Total Funding Amount',
    id: FilterResponseContact.Total_Funding_Amount,
    type: 'min-max',
  },
  {
    label: 'Job Openings',
    id: FilterResponseContact.Job_Openings,
    type: 'multi-select',
  },
  {
    label: 'Verified Email',
    id: FilterResponseContact.Verified_Email,
    type: 'multi-select',
  },
  {
    label: 'Source',
    id: FilterResponseContact.Source,
    type: 'multi-select',
  },
  {
    label: 'Contact Owner',
    id: FilterResponseContact.Contact_Owner,
    type: 'multi-select',
  },
  {
    label: 'Number of visits',
    id: FilterResponseContact.Number_of_visits,
    type: 'min-max',
  },
  {
    label: 'Last Visited Date',
    id: FilterResponseContact.Last_Visited_Date,
    type: 'date-range',
  },
  {
    label: 'Source File',
    id: FilterResponseContact.Source_File,
    type: 'multi-select',
  },
];

// accounts

export const FilterResponseAccount = {
  Organization: 'Organization',
  Country: 'Country',
  State: 'State',
  City: 'City',
  Company_Region: 'Company Region',
  Industry: 'Industry',
  Revenue: 'Revenue',
  Employee_Count: 'Employee Count',
  Intent_Topics: 'Intent Topics',
  Intent_Score: 'Intent Score',
  Latest_Funding_Stage: 'Latest Funding Stage',
  Latest_Funding_Amount: 'Latest Funding Amount',
  Latest_Funding_Date: 'Latest Funding Date',
  Total_Funding_Amount: 'Total Funding Amount',
  Job_Openings: 'Job Openings',
  Account_Owner: 'Account Owner',
  Address: 'Address',
  Last_Visited_Date: 'Last Visited Date', // not a response
  Number_of_visits: 'Number of visits',
  Source_File: 'Source File',
  Qualification: 'Qualification',
};

export const AccountFilterGroup: WebAccFilterGroupType[] = [
  {
    label: 'Company',
    groups: [{ label: 'Company', key: FilterResponseAccount.Organization }],
  },
  {
    label: 'Country',
    groups: [{ label: 'Country', key: FilterResponseAccount.Country }],
  },
  {
    label: 'State',
    groups: [{ label: 'State', key: FilterResponseAccount.State }],
  },
  {
    label: 'City',
    groups: [{ label: 'City', key: FilterResponseAccount.City }],
  },
  // {
  //   label: 'Location',
  //   groups: [
  //     { label: 'Country', key: FilterResponseContact.Country },
  //     { label: 'State', key: FilterResponseContact.State },
  //     { label: 'City', key: FilterResponseContact.City },
  //   ],
  // },
  {
    label: 'Company Region',
    groups: [{ label: 'Company Region', key: FilterResponseAccount.Company_Region }],
  },

  {
    label: 'Industry',
    groups: [{ label: 'Industry', key: FilterResponseAccount.Industry }],
  },
  {
    label: 'Revenue',
    groups: [{ label: 'Revenue', key: FilterResponseAccount.Revenue }],
  },
  {
    label: 'Employee Count',
    groups: [{ label: 'Employee Count', key: FilterResponseAccount.Employee_Count }],
  },
  {
    label: 'Intent Topics',
    groups: [{ label: 'Intent Topics', key: FilterResponseAccount.Intent_Topics }],
  },
  {
    label: 'Intent Score',
    groups: [{ label: 'Intent Score', key: FilterResponseAccount.Intent_Score }],
  },
  {
    label: 'Latest Funding Stage',
    groups: [{ label: 'Latest Funding Stage', key: FilterResponseAccount.Latest_Funding_Stage }],
  },
  {
    label: 'Latest Funding Amount',
    groups: [{ label: 'Latest Funding Amount', key: FilterResponseAccount.Latest_Funding_Amount }],
  },
  {
    label: 'Latest Funding Date',
    groups: [{ label: 'Latest Funding Date', key: FilterResponseAccount.Latest_Funding_Date }],
  },
  {
    label: 'Total Funding Amount',
    groups: [{ label: 'Total Funding Amount', key: FilterResponseAccount.Total_Funding_Amount }],
  },
  {
    label: 'Job Openings',
    groups: [{ label: 'Job Openings', key: FilterResponseAccount.Job_Openings }],
  },
  {
    label: 'Account Owner',
    groups: [{ label: 'Account Owner', key: FilterResponseAccount.Account_Owner }],
  },
  {
    label: 'Address',
    groups: [{ label: 'Address', key: FilterResponseAccount.Address }],
  },
  {
    label: 'Number of visits',
    groups: [{ label: 'Number of visits', key: FilterResponseAccount.Number_of_visits }],
  },
  {
    label: 'Last Visited Date',
    groups: [{ label: 'Last Visited Date', key: FilterResponseAccount.Last_Visited_Date }],
  },
  {
    label: 'Source File',
    groups: [{ label: 'Source File', key: FilterResponseAccount.Source_File }],
  },
  {
    label: 'Qualification',
    groups: [{ label: 'Qualification', key: FilterResponseAccount.Qualification }],
  },
  // {
  //   label: 'Funding',
  //   groups: [
  //     { label: 'Date range', key: webAccFilterResponse.dateRange },
  //     { label: '# visits', key: webAccFilterResponse.Number_of_visits },
  //   ],
  // },
  // {
  //   label: 'Website visits',
  //   groups: [
  //     { label: 'Stage', key: webAccFilterResponse.Latest_Funding_Stage },
  //     { label: 'Total funding amount', key: webAccFilterResponse.Total_Funding_Amount },
  //   ],
  // },
];

export const AccountFilterArrayData = [
  {
    label: 'Company',
    id: FilterResponseAccount.Organization,
    type: 'multi-select',
  },
  {
    label: 'Country',
    id: FilterResponseAccount.Country,
    type: 'multi-select',
  },
  {
    label: 'State',
    id: FilterResponseAccount.State,
    type: 'multi-select',
  },
  {
    label: 'City',
    id: FilterResponseAccount.City,
    type: 'multi-select',
  },
  {
    label: 'Company Region',
    id: FilterResponseAccount.Company_Region,
    type: 'multi-select',
  },

  {
    label: 'Industry',
    id: FilterResponseAccount.Industry,
    type: 'multi-select',
  },
  {
    label: 'Revenue',
    id: FilterResponseAccount.Revenue,
    type: 'min-max',
  },
  {
    label: 'Employee Count',
    id: FilterResponseAccount.Employee_Count,
    type: 'min-max',
  },
  {
    label: 'Intent Topics',
    id: FilterResponseAccount.Intent_Topics,
    type: 'multi-select',
  },
  {
    label: 'Intent Score',
    id: FilterResponseAccount.Intent_Score,
    type: 'intent-score-v2',
  },

  {
    label: 'Latest Funding Stage',
    id: FilterResponseAccount.Latest_Funding_Stage,
    type: 'multi-select',
  },
  {
    label: 'Latest Funding Amount',
    id: FilterResponseAccount.Latest_Funding_Amount,
    type: 'min-max',
  },
  {
    label: 'Latest Funding Date',
    id: FilterResponseAccount.Latest_Funding_Date,
    type: 'date-range',
  },
  {
    label: 'Total Funding Amount',
    id: FilterResponseAccount.Total_Funding_Amount,
    type: 'min-max',
  },
  {
    label: 'Job Openings',
    id: FilterResponseAccount.Job_Openings,
    type: 'multi-select',
  },
  {
    label: 'Account Owner',
    id: FilterResponseAccount.Account_Owner,
    type: 'multi-select',
  },
  {
    label: 'Address',
    id: FilterResponseAccount.Address,
    type: 'multi-select',
  },
  {
    label: 'Number of visits',
    id: FilterResponseAccount.Number_of_visits,
    type: 'min-max',
  },
  {
    label: 'Source File',
    id: FilterResponseAccount.Source_File,
    type: 'multi-select',
  },
  {
    label: 'Last Visited Date',
    id: FilterResponseAccount.Last_Visited_Date,
    type: 'date-range',
  },
  {
    label: 'Qualification',
    id: FilterResponseAccount.Qualification,
    type: 'multi-select',
  },
];

import {
  generateSecureState,
  storeOAuthState,
  generatePKCE,
  storePKCEVerifier,
} from 'src/utils/utilityMethods';

function getRedirectUri(): string {
  return `${window.location.origin}/settings/integrate`;
}

const redirect_uri = getRedirectUri();

// URLs for different OAuth providers
const hubspotConnectUrl: Record<string, string> = {
  qa: `https://app.hubspot.com/oauth/authorize?client_id=d892c97c-113b-4965-880e-57336daa1c6f&redirect_uri=${redirect_uri}/hubspot&scope=crm.schemas.companies.write%20crm.schemas.quotes.read%20crm.schemas.contacts.write%20crm.objects.line_items.read%20crm.schemas.deals.read%20crm.objects.line_items.write%20crm.schemas.deals.write%20crm.schemas.line_items.read%20crm.objects.owners.read%20settings.users.teams.read%20crm.objects.leads.read%20crm.objects.leads.write%20crm.objects.contacts.write%20crm.schemas.custom.read%20crm.objects.custom.read%20crm.objects.custom.write%20crm.objects.companies.write%20crm.lists.write%20crm.objects.goals.read%20crm.objects.companies.read%20crm.lists.read%20settings.users.read%20crm.objects.deals.read%20crm.schemas.contacts.read%20crm.objects.deals.write%20crm.objects.quotes.write%20crm.objects.contacts.read%20cms.domains.read%20crm.schemas.companies.read%20crm.objects.quotes.read`,
  prod: `https://app.hubspot.com/oauth/authorize?client_id=5f5692cd-b236-4bf0-88d6-35cd9b2837ca&redirect_uri=${redirect_uri}/hubspot&scope=crm.objects.contacts.read%20crm.objects.contacts.write%20crm.objects.companies.write%20settings.users.read%20crm.schemas.contacts.read%20crm.objects.companies.read%20crm.objects.deals.read%20crm.schemas.companies.read%20crm.schemas.deals.read%20crm.objects.owners.read%20crm.objects.leads.read%20crm.objects.leads.write`,
};
const salesforceClientIds: Record<string, string> = {
  qa: '3MVG9jSKmPAPVo2Kxxoy1eHfEiS5mgBpqQ7AmsVpanH89U5N8.E8bfdfLJA__cVFCblt.lBAz90.XAsFb34Ew',
  prod: '3MVG9jSKmPAPVo2Kxxoy1eHfEiZWCyc5VB_5PNLbJ9h_uOF35dxlioERZfaTn.soevN9laP6ho8HEaZp7K8MB',
};
const buildSalesforceAuthUrl = (clientId: string, callbackPath: 'salesforce') =>
  `https://login.salesforce.com/services/oauth2/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirect_uri}/${callbackPath}`;

export const salesforceConnectUrl: Record<string, string> = {
  qa: buildSalesforceAuthUrl(salesforceClientIds.qa, 'salesforce'),
  prod: buildSalesforceAuthUrl(salesforceClientIds.prod, 'salesforce'),
};
export const getSalesforcePkceConnectUrl = async (
  callbackPath: 'salesforce',
  provider: 'salesforce',
  currentEnv: string,
): Promise<string> => {
  const { codeVerifier, codeChallenge } = await generatePKCE();
  storePKCEVerifier(codeVerifier, provider);
  const clientId = salesforceClientIds[currentEnv] || salesforceClientIds.qa;
  return (
    `https://login.salesforce.com/services/oauth2/authorize?` +
    `client_id=${clientId}` +
    `&response_type=code` +
    `&redirect_uri=${encodeURIComponent(`${redirect_uri}/${callbackPath}`)}` +
    `&code_challenge=${encodeURIComponent(codeChallenge)}` +
    `&code_challenge_method=S256`
  );
};
const pipedriveConnectUrl: Record<string, string> = {
  qa: `https://oauth.pipedrive.com/oauth/authorize?client_id=1034a517f00a6506&redirect_uri=${redirect_uri}/pipedrive`,
  prod: `https://oauth.pipedrive.com/oauth/authorize?client_id=ba8ea38cac54a7d8&redirect_uri=${redirect_uri}/pipedrive`,
};
const outreachConnectUrl: Record<string, string> = {
  qa: `https://api.outreach.io/oauth/authorize?client_id=zgmnRdwSV1lI~jyF77uIHoovyXRDM8OEc5RQBiLm8k-5&redirect_uri=${redirect_uri}/outreach&response_type=code&scope=accounts.all%20calls.all%20callDispositions.all%20callPurposes.all%20complianceRequests.all%20contentCategories.all%20contentCategoryMemberships.all%20contentCategoryOwnerships.all%20customDuties.write%20duties.read%20emailAddresses.all%20events.all%20favorites.all%20jobRoles.all%20mailboxes.all%20mailings.all%20mailAliases.read%20opportunities.all%20opportunityProspectRoles.all%20opportunityStages.all%20orgSettings.all%20personas.all%20phoneNumbers.all%20profiles.all%20prospects.all%20recipients.all%20recordActorAssignments.all%20roles.all%20rulesets.all%20sequences.all%20sequenceStates.all%20sequenceSteps.all%20sequenceTemplates.all%20snippets.all%20stages.all%20tasks.all%20taskPriorities.read%20teams.all%20templates.all%20users.all%20webhooks.all%20scim`,
  prod: `https://api.outreach.io/oauth/authorize?client_id=zgmnRdwSV1lI~jyF77uIHoovyXRDM8OEc5RQBiLm8k-5&redirect_uri=${redirect_uri}/outreach&response_type=code&scope=accounts.all%20calls.all%20callDispositions.all%20callPurposes.all%20complianceRequests.all%20contentCategories.all%20contentCategoryMemberships.all%20contentCategoryOwnerships.all%20customDuties.write%20duties.read%20emailAddresses.all%20events.all%20favorites.all%20jobRoles.all%20mailboxes.all%20mailings.all%20mailAliases.read%20opportunities.all%20opportunityProspectRoles.all%20opportunityStages.all%20orgSettings.all%20personas.all%20phoneNumbers.all%20profiles.all%20prospects.all%20recipients.all%20recordActorAssignments.all%20roles.all%20rulesets.all%20sequences.all%20sequenceStates.all%20sequenceSteps.all%20sequenceTemplates.all%20snippets.all%20stages.all%20tasks.all%20taskPriorities.read%20teams.all%20templates.all%20users.all%20webhooks.all%20scim`,
};

const ZOHO_REQUIRED_SCOPES = [
  'ZohoCRM.users.READ',
  'ZohoCRM.settings.READ',
  'ZohoCRM.modules.contacts.READ',
  'ZohoCRM.modules.contacts.CREATE',
  'ZohoCRM.modules.contacts.UPDATE',
  'ZohoCRM.modules.leads.READ',
  'ZohoCRM.modules.leads.CREATE',
  'ZohoCRM.modules.leads.UPDATE',
  'ZohoCRM.modules.accounts.READ',
  'ZohoCRM.modules.accounts.CREATE',
  'ZohoCRM.modules.accounts.UPDATE',
  'ZohoCRM.modules.deals.READ',
  'ZohoCRM.modules.deals.CREATE',
  'ZohoCRM.modules.deals.UPDATE',
  'ZohoCRM.modules.tasks.READ',
  'ZohoCRM.modules.tasks.CREATE',
  'ZohoCRM.modules.tasks.UPDATE',
  'ZohoCRM.modules.calls.READ',
  'ZohoCRM.modules.calls.CREATE',
  'ZohoCRM.modules.calls.UPDATE',
  'ZohoCRM.modules.notes.READ',
  'ZohoCRM.modules.notes.CREATE',
  'ZohoCRM.modules.notes.UPDATE',
  'ZohoCRM.modules.emails.READ',
  'ZohoCRM.modules.emails.CREATE',
  'ZohoCRM.modules.emails.UPDATE',
  'ZohoCRM.coql.READ',
].join(',');

const zohoConnectUrl: Record<string, string> = {
  qa: `https://accounts.zoho.com/oauth/v2/auth?scope=${ZOHO_REQUIRED_SCOPES}&client_id=1000.BQ49OZ9JBCFHFXW924AOSSCG88A3YT&response_type=code&access_type=offline&redirect_uri=${redirect_uri}/zoho`,
  prod: `https://accounts.zoho.com/oauth/v2/auth?scope=${ZOHO_REQUIRED_SCOPES}&client_id=1000.L3DVB628Z570W95MBT25CE5VHULXIQ&response_type=code&access_type=offline&redirect_uri=${redirect_uri}/zoho`,
};

const microsoftConnectUrl: Record<string, (orgUrl?: string) => string> = {
  qa: (orgUrl = 'globaldisco.crm.dynamics.com') => {
    const scope = `openid offline_access profile https://${orgUrl}/user_impersonation`;
    const state = generateSecureState();
    storeOAuthState(state, 'microsoft');

    return (
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
      `client_id=2ee4a12b-61a9-4b5d-b8b6-749628003f55` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(`${redirect_uri}/microsoft`)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent(scope)}` +
      `&state=${encodeURIComponent(state)}` +
      `&prompt=consent`
    );
  },

  prod: (orgUrl = 'globaldisco.crm.dynamics.com') => {
    const scope = `openid offline_access profile https://${orgUrl}/user_impersonation`;
    const state = generateSecureState();
    storeOAuthState(state, 'microsoft');

    return (
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
      `client_id=2ee4a12b-61a9-4b5d-b8b6-749628003f55` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(`${redirect_uri}/microsoft`)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent(scope)}` +
      `&state=${encodeURIComponent(state)}` +
      `&prompt=consent`
    );
  },
};

const gongConnectUrl: Record<string, () => string> = {
  qa: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'gong');
    return `https://app.gong.io/oauth2/authorize?client_id=zzhipyu8&response_type=code&scope=api:calls:read:transcript%20api:workspaces:read%20api:crm:get-objects%20api:crm:schema%20api:meetings:integration:status%20api:calls:read:extensive%20api:settings:scorecards:read%20api:stats:scorecards%20api:calls:read:basic%20api:calls:read:media-url%20api:users:read%20api:permission-profile:read%20api:crm-calls:manual-association:read%20api:call-outcomes:read&redirect_uri=${redirect_uri}/gong&state=${encodeURIComponent(
      state,
    )}`;
  },
  prod: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'gong');
    return `https://app.gong.io/oauth2/authorize?client_id=zzhipyu8&response_type=code&scope=api:calls:read:transcript%20api:workspaces:read%20api:crm:get-objects%20api:crm:schema%20api:meetings:integration:status%20api:calls:read:extensive%20api:settings:scorecards:read%20api:stats:scorecards%20api:calls:read:basic%20api:calls:read:media-url%20api:users:read%20api:permission-profile:read%20api:crm-calls:manual-association:read%20api:call-outcomes:read&redirect_uri=${redirect_uri}/gong&state=${encodeURIComponent(
      state,
    )}`;
  },
};

const salesloftConnectUrl: Record<string, () => string> = {
  qa: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'salesloft');
    return `https://accounts.salesloft.com/oauth/authorize?client_id=119450_5272e1f80a56986c741c810abd781be8b06197a186d8b366056d3b37d822c01f&redirect_uri=${redirect_uri}/salesloft&response_type=code&scope=accounts:read%20accounts:write%20opportunities:read%20opportunities:write%20people:read%20people:write%20external_id:read%20external_id_configuration:read%20activities:read%20activities:write%20calls:read%20calls:write%20conversations:read%20conversations:write%20dialer_recordings:read%20emails:read%20emails:write%20meetings:read%20meetings:write%20notifications:write%20team:read%20cadences:read%20cadences:write%20notes:read%20notes:write%20tasks:read%20tasks:write%20workflow:read%20workflow:write%20crm_id_account:write%20crm_id_person:write%20email_bodies%20email_contents&state=${encodeURIComponent(
      state,
    )}`;
  },
  prod: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'salesloft');
    return `https://accounts.salesloft.com/oauth/authorize?client_id=119450_76fd4eb7fe8d542faba782e891c41b515613c7b8e317274c2e0aafe59ea409ff&redirect_uri=${redirect_uri}/salesloft&response_type=code&scope=accounts:read%20accounts:write%20opportunities:read%20opportunities:write%20people:read%20people:write%20external_id:read%20external_id_configuration:read%20activities:read%20activities:write%20calls:read%20calls:write%20conversations:read%20conversations:write%20dialer_recordings:read%20emails:read%20emails:write%20meetings:read%20meetings:write%20notifications:write%20team:read%20cadences:read%20cadences:write%20notes:read%20notes:write%20workflow:read%20workflow:write%20crm_id_account:write%20crm_id_person:write%20email_bodies%20email_contents&state=${encodeURIComponent(
      state,
    )}`;
  },
};

const mailchimpConnectUrl: Record<string, string> = {
  qa: `https://login.mailchimp.com/oauth2/authorize?response_type=code&scope=lists_read%20lists_write%20campaigns_read%20campaigns_write%20templates_read%20templates_write%20automations_read%20automations_write&client_id=949605102808&redirect_uri=${redirect_uri}/mailchimp`,
  prod: `https://login.mailchimp.com/oauth2/authorize?response_type=code&scope=lists_read%20lists_write%20campaigns_read%20campaigns_write%20templates_read%20templates_write%20automations_read%20automations_write&client_id=827450480961&redirect_uri=${redirect_uri}/mailchimp`,
};

const pardotConnectUrl: Record<string, (businessUnitId: string) => Promise<string>> = {
  qa: async (businessUnitId: string) => {
    const state = generateSecureState();
    const { codeVerifier, codeChallenge } = await generatePKCE();

    storeOAuthState(state, 'pardot');
    storePKCEVerifier(codeVerifier, 'pardot');

    return (
      `https://login.salesforce.com/services/oauth2/authorize?` +
      `client_id=3MVG9jSKmPAPVo2Kxxoy1eHfEiWwr_tcd0aiPB19.7aCv964BTveGUePmfrxu7ijo_ZZIwsdjLMcj3uWJzscl` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(`${redirect_uri}/pardot`)}` +
      `&scope=pardot_api%20refresh_token%20offline_access` +
      `&state=${encodeURIComponent(state)}` +
      `&code_challenge=${encodeURIComponent(codeChallenge)}` +
      `&code_challenge_method=S256`
    );
  },

  prod: async (businessUnitId: string) => {
    const state = generateSecureState();
    const { codeVerifier, codeChallenge } = await generatePKCE();

    // Store state and PKCE verifier for callback validation
    storeOAuthState(state, 'pardot');
    storePKCEVerifier(codeVerifier, 'pardot');

    return (
      `https://login.salesforce.com/services/oauth2/authorize?` +
      `client_id=3MVG9jSKmPAPVo2Kxxoy1eHfEiWwr_tcd0aiPB19.7aCv964BTveGUePmfrxu7ijo_ZZIwsdjLMcj3uWJzscl` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(`${redirect_uri}/pardot`)}` +
      `&scope=pardot_api%20refresh_token%20offline_access` +
      `&state=${encodeURIComponent(state)}` +
      `&code_challenge=${encodeURIComponent(codeChallenge)}` +
      `&code_challenge_method=S256`
    );
  },
};

// AUTH_ONLY Integrations - Simple OAuth with no configuration stages
// These use /settings/connect/:integration redirect pattern (not /settings/integrate)
const gmailConnectUrl: Record<string, () => string> = {
  qa: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'gmail');
    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}/settings/connect/gmail`)}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(
        'https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/admin.directory.user.readonly https://www.googleapis.com/auth/contacts.readonly',
      )}` +
      `&access_type=offline` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`
    );
  },
  prod: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'gmail');
    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}/settings/connect/gmail`)}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(
        'https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/admin.directory.user.readonly https://www.googleapis.com/auth/contacts.readonly',
      )}` +
      `&access_type=offline` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`
    );
  },
};

const googleDriveConnectUrl: Record<string, () => string> = {
  qa: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'googledrive');
    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/googledrive`,
      )}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(
        'https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/admin.directory.user.readonly',
      )}` +
      `&access_type=offline` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`
    );
  },
  prod: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'googledrive');
    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/googledrive`,
      )}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(
        'https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/admin.directory.user.readonly',
      )}` +
      `&access_type=offline` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`
    );
  },
};

const googleSlidesConnectUrl: Record<string, () => string> = {
  qa: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'googleslides');
    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/googleslides`,
      )}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(
        'https://www.googleapis.com/auth/presentations.readonly https://www.googleapis.com/auth/admin.directory.user.readonly',
      )}` +
      `&access_type=offline` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`
    );
  },
  prod: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'googleslides');
    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/googleslides`,
      )}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(
        'https://www.googleapis.com/auth/presentations.readonly https://www.googleapis.com/auth/admin.directory.user.readonly',
      )}` +
      `&access_type=offline` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`
    );
  },
};

const googleDocsConnectUrl: Record<string, () => string> = {
  qa: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'googledocs');
    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/googledocs`,
      )}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(
        'https://www.googleapis.com/auth/documents.readonly https://www.googleapis.com/auth/admin.directory.user.readonly',
      )}` +
      `&access_type=offline` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`
    );
  },
  prod: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'googledocs');
    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/googledocs`,
      )}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(
        'https://www.googleapis.com/auth/documents.readonly https://www.googleapis.com/auth/admin.directory.user.readonly',
      )}` +
      `&access_type=offline` +
      `&prompt=consent` +
      `&state=${encodeURIComponent(state)}`
    );
  },
};

const googleAnalyticsConnectUrl: Record<string, () => string> = {
  qa: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'googleanalytics');

    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/googleanalytics`,
      )}` +
      `&response_type=code` +
      `&access_type=offline` +
      `&include_granted_scopes=true` +
      `&prompt=consent` +
      `&scope=${encodeURIComponent(
        'openid email profile ' +
          'https://www.googleapis.com/auth/analytics.readonly ' +
          'https://www.googleapis.com/auth/bigquery.readonly',
      )}` +
      `&state=${encodeURIComponent(state)}`
    );
  },

  dev: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'googleanalytics');

    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/googleanalytics`,
      )}` +
      `&response_type=code` +
      `&access_type=offline` +
      `&include_granted_scopes=true` +
      `&prompt=consent` +
      `&scope=${encodeURIComponent(
        'openid email profile ' +
          'https://www.googleapis.com/auth/analytics.readonly ' +
          'https://www.googleapis.com/auth/bigquery.readonly',
      )}` +
      `&state=${encodeURIComponent(state)}`
    );
  },

  prod: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'googleanalytics');

    return (
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=875743275536-ag6kh7fgo436jqcl2csbukc7s983c2pr.apps.googleusercontent.com` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/googleanalytics`,
      )}` +
      `&response_type=code` +
      `&access_type=offline` +
      `&include_granted_scopes=true` +
      `&prompt=consent` +
      `&scope=${encodeURIComponent(
        'openid email profile ' +
          'https://www.googleapis.com/auth/analytics.readonly ' +
          'https://www.googleapis.com/auth/bigquery.readonly',
      )}` +
      `&state=${encodeURIComponent(state)}`
    );
  },
};

const slackConnectUrl: Record<string, () => string> = {
  qa: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'slack');
    return (
      `https://slack.com/oauth/v2/authorize?` +
      `client_id=4642043244228.9926576419333` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}/settings/connect/slack`)}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(
        'channels:read,groups:read,users:read,chat:write,files:read,reactions:read',
      )}` +
      `&state=${encodeURIComponent(state)}`
    );
  },
  prod: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'slack');
    return (
      `https://slack.com/oauth/v2/authorize?` +
      `client_id=4642043244228.9926576419333` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}/settings/connect/slack`)}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(
        'channels:read,groups:read,users:read,chat:write,files:read,reactions:read',
      )}` +
      `&state=${encodeURIComponent(state)}`
    );
  },
};

const amplitudeConnectUrl: Record<string, () => string> = {
  qa: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'amplitude');
    return (
      `https://amplitude.com/oauth/authorize?` +
      `client_id=dggsgdsgdggdsgsgdasgfadsgg` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/amplitude`,
      )}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent('read:data,read:projects')}` +
      `&state=${encodeURIComponent(state)}`
    );
  },
  prod: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'amplitude');
    return (
      `https://amplitude.com/oauth/authorize?` +
      `client_id=dggsgdsgdggdsgsgdasgfadsgg` +
      `&redirect_uri=${encodeURIComponent(
        `${window.location.origin}/settings/connect/amplitude`,
      )}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent('read:data,read:projects')}` +
      `&state=${encodeURIComponent(state)}`
    );
  },
};

const segmentConnectUrl: Record<string, () => string> = {
  qa: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'segment');
    return (
      `https://app.segment.com/oauth2/authorize?` +
      `client_id=dagdgdsgsgsagdgs` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}/settings/connect/segment`)}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent('workspace.read,source.read')}` +
      `&state=${encodeURIComponent(state)}`
    );
  },
  prod: () => {
    const state = generateSecureState();
    storeOAuthState(state, 'segment');
    return (
      `https://app.segment.com/oauth2/authorize?` +
      `client_id=dagdgdsgsgsagdgs` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}/settings/connect/segment`)}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent('workspace.read,source.read')}` +
      `&state=${encodeURIComponent(state)}`
    );
  },
};

const resolveConnectUrl = (url: string | (() => string)): string => {
  return typeof url === 'function' ? url() : url;
};

// Selecting the appropriate URLs based on environment
const env = process.env.REACT_APP_DEV_ENV || 'qa';

export const HubSpotConnectUrl = resolveConnectUrl(hubspotConnectUrl[env]);
export const SalesforceConnectUrl = resolveConnectUrl(salesforceConnectUrl[env]);
export const PipedriveConnectUrl = resolveConnectUrl(pipedriveConnectUrl[env]);
export const OutreachConnectUrl = resolveConnectUrl(outreachConnectUrl[env]);
export const ZohoConnectUrl = resolveConnectUrl(zohoConnectUrl[env]);
export const GongConnectUrl = resolveConnectUrl(gongConnectUrl[env]);
export const SalesloftConnectUrl = resolveConnectUrl(salesloftConnectUrl[env]);
export const MailchimpConnectUrl = resolveConnectUrl(mailchimpConnectUrl[env]);

// MS Teams OAuth Configuration
const teamsConnectUrl: Record<string, () => string> = {
  qa: () => {
    const scope = `openid offline_access profile User.Read Chat.Read Team.ReadBasic.All Channel.ReadBasic.All`;
    const state = generateSecureState();
    storeOAuthState(state, 'microsoft_teams');
    return (
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
      `client_id=a907ccf4-2302-4616-9a54-b16116d6b8c2` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}/settings/connect/teams`)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent(scope)}` +
      `&state=${encodeURIComponent(state)}` +
      `&prompt=consent`
    );
  },
  prod: () => {
    const scope = `openid offline_access profile User.Read Chat.Read Team.ReadBasic.All Channel.ReadBasic.All`;
    const state = generateSecureState();
    storeOAuthState(state, 'microsoft_teams');
    return (
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
      `client_id=a907ccf4-2302-4616-9a54-b16116d6b8c2` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}/settings/connect/teams`)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent(scope)}` +
      `&state=${encodeURIComponent(state)}` +
      `&prompt=consent`
    );
  },
};

// Outlook OAuth Configuration
const outlookConnectUrl: Record<string, () => string> = {
  qa: () => {
    const scope = `openid offline_access Mail.Read User.Read`;
    const state = generateSecureState();
    storeOAuthState(state, 'outlook');

    return (
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
      `client_id=a907ccf4-2302-4616-9a54-b16116d6b8c2` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}/settings/connect/outlook`)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent(scope)}` +
      `&state=${encodeURIComponent(state)}` +
      `&prompt=consent`
    );
  },
  prod: () => {
    const scope = `openid offline_access Mail.Read User.Read`;
    const state = generateSecureState();
    storeOAuthState(state, 'outlook');

    return (
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?` +
      `client_id=a907ccf4-2302-4616-9a54-b16116d6b8c2` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(`${window.location.origin}/settings/connect/outlook`)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent(scope)}` +
      `&state=${encodeURIComponent(state)}` +
      `&prompt=consent`
    );
  },
};

// AUTH_ONLY Integrations
// Using resolveConnectUrl() to call functions at module load and resolve to strings
// Provider-specific OAuth state keys (oauth_state_gmail, oauth_state_slack, etc.) prevent overwrites
export const GmailConnectUrl = resolveConnectUrl(gmailConnectUrl[env]);
export const GoogleDriveConnectUrl = resolveConnectUrl(googleDriveConnectUrl[env]);
export const GoogleSlidesConnectUrl = resolveConnectUrl(googleSlidesConnectUrl[env]);
export const GoogleDocsConnectUrl = resolveConnectUrl(googleDocsConnectUrl[env]);
export const GoogleAnalyticsConnectUrl = resolveConnectUrl(googleAnalyticsConnectUrl[env]);
export const SlackConnectUrl = resolveConnectUrl(slackConnectUrl[env]);
export const AmplitudeConnectUrl = resolveConnectUrl(amplitudeConnectUrl[env]);
export const SegmentConnectUrl = resolveConnectUrl(segmentConnectUrl[env]);
export const TeamsConnectUrl = resolveConnectUrl(teamsConnectUrl[env]);
export const OutlookConnectUrl = resolveConnectUrl(outlookConnectUrl[env]);

// Special cases: Microsoft and Pardot require parameters
export const MicrosoftConnectUrl = microsoftConnectUrl[env];
export const PardotConnectUrl = pardotConnectUrl[env];

export const campaignStages = {
  Unknown: 'Black',
  '(None)': 'Black',
  '(Unavailable)': 'Black',
  'Contact in future': 'Green',
  'Replied interested': 'Green',
  Approaching: 'Orange',
  'Cold/Not Started': 'Orange',
  Unresponsive: 'Orange',
  'Do not contact': 'Red',
  'Replied not interested': 'Red',
  'Bad contact info': 'Red',
  'No big enough budget': 'Red',
  'Not a joker/fit': 'Red',
  'Opted out': 'Red',
  'Too small': 'Red',
  'Not a priority': 'Red',
  'Not ready to buy': 'Red',
  Unsubscribed: 'Red',
  // ? Add other statuses if any in future
};

// ? This function takes an Array of Fallbacks and return the first truthy value in that fallback array
export function falsyFallbackFunction<T>(...args: Array<T | null | undefined>): T | undefined {
  for (const arg of args) {
    // ? Manually typed conditions will look like this: (arg !== null && arg !== undefined && !(typeof arg === 'string' && arg.trim() === ''))
    if (arg) {
      return arg;
    }
  }
  return undefined;
}
export const carouselData = [
  {
    heading: 'Increase your chances of marketing success by 674%',
    body: `B2B marketing success is never accidental but a result of strategic planning, continuous improvement, and outpacing your competition. Every interaction holds the potential to shape your brand's future, and your marketing strategy serves as the cornerstone of y0our business's growth.`,
    url: 'https://sprouts.ai/increase-your-chances-of-marketing-success-by-674/',
  },
  {
    heading: 'BDR vs. SDR: Understanding the Key Differences in Sales Roles',
    body: 'BDR stands for Business Development Representative, while SDR stands for Sales Development Representative. These roles play a pivotal part in driving the success of modern businesses. ',
    url: 'https://sprouts.ai/bdr-vs-sdr-understanding-the-key-differences-in-sales-roles/',
  },
  {
    heading: 'Martech’s Long Tail: An Ecosystem of Innovation',
    body: 'The Martech landscape is like a vast jungle, teeming with over 11,000 products. Let the number sink in – 11,000 products!  Big companies like Adobe and Salesforce are at the top, enjoying billions of dollars. But hiding below and in the thick bushes, there is a lively place – called “long tail.”',
    url: 'https://sprouts.ai/martechs-long-tail-an-ecosystem-of-innovation/',
  },
  {
    heading: 'Precision Targeting: Crafting Effective Psychographic Profiles for Ideal Prospects',
    body: 'Change is the only constant, and businesses are constantly looking for ways to redefine how they connect with their ideal customers. Gone are the days of casting a wide net and hoping for the best; the era of precision targeting has dawned. Explore the art and science of crafting compelling psychographic profiles to pinpoint and engage with your ideal prospects.',
    url: 'https://sprouts.ai/precision-targeting-crafting-effective-psychographic-profiles-for-ideal-prospects/',
  },
  {
    heading: 'The Cost of Data Decay: How Outdated Information Is Draining Your Profits',
    body: 'Data fuels decision-making processes that can make or break an enterprise, from customer preferences to market trends. However, like perishable goods on a supermarket shelf, data has a shelf life, and when it decays, the consequences can be severe. In this blog, we’ll explore the concept of data decay, why it matters, and how it can impact your bottom line.',
    url: 'https://sprouts.ai/the-cost-of-data-decay-how-outdated-information-is-draining-your-profits/',
  },
  {
    heading: 'Unleashing the Sales Jedi: How Prospector Tools Turbocharge Conversions',
    body: 'We’ve all been there, cold calling, emailing, and chasing leads, only to feel like we’re spinning our wheels. But fear not, for in this blog post, we’re going to talk about a secret weapon that can accelerate your sales game and bring in those much-coveted conversions: sales prospector tools! ',
    url: 'https://sprouts.ai/unleashing-the-sales-jedi-how-prospector-tools-turbocharge-conversions/',
  },
  {
    heading: 'How to Train SDRs in Cold Calling? [Coaching Tips & Ideas] ',
    body: 'Mastering the art of cold calling is not just a skill; it’s a strategic imperative for Sales Development Representatives (SDRs). Cold calling, though often viewed as a daunting task, remains crucial in the sales process, offering a direct and personal connection with potential customers. Excelling at cold calling isn’t just about following a script like it’s a magic wand. It’s way more than that. Let’s explore some key coaching tips and ideas to empower your SDRs and elevate their cold-calling game.',
    url: 'https://sprouts.ai/how-to-train-sdrs-in-cold-calling-coaching-tips-ideas/',
  },
  {
    heading: 'Decoding Firmographic Data: Elevating Your Sales Intelligence for Success',
    body: 'Sales success often depends on the ability to gather and understand relevant data. The capability to navigate and leverage information is a linchpin for companies striving to outperform their competition. One such data type that significantly contributes to enhanced sales intelligence is firmographic data, which provides valuable insights into a company’s characteristics and serves as a cornerstone for effective sales strategies. ',
    url: 'https://sprouts.ai/decoding-firmographic-data-elevating-your-sales-intelligence-for-success/ ',
  },
  {
    heading: 'ToFu to BoFu Faster Than Ever: Revolutionizing the Buyer Journey',
    body: 'We know already how in today’s day and age where attention spans are fleeting and competition is fierce, marketers are faced with the daunting task of capturing the hearts and minds of potential customers in record time. Gone are the days of lengthy, drawn-out sales processes. Right now, it’s all about speed, agility, and delivering value at every stage of the buyer journey.',
    url: 'https://sprouts.ai/tofu-to-bofu-faster-than-ever-revolutionizing-the-buyer-journey/',
  },
  {
    heading: 'Inbox Mastery: A Comprehensive Playbook for Email Outreach Success in FY`24',
    body: 'While social media platforms buzz with tweets, posts, and messages, it`s easy to overlook the OG of digital communication: the email. Did you know that personalized emails deliver 6x higher transaction rates & 79% of B2B marketers consider email to be the most effective demand gen channel.',
    url: 'https://sprouts.ai/inbox-mastery-a-comprehensive-playbook-for-email-outreach-success-in-fy24/ ',
  },
];

export const RemoveFiltersIfWebsiteVisitsFlagOff = [
  'Number of visits',
  'Last Visited Date',
  'Visiting Location',
  'Pages visited',
  'Webpages',
  'UTM Source',
  'UTM Medium',
  'UTM Campaign',
  'Visiting Country',
  'Visiting City',
  'Visiting State',
  'Qualification',
];

export const SPROUTS_ADMIN_DOMAIN = 'sprouts.ai';

export const featureFlagsInitialState: { [key: string]: boolean | undefined } = {
  // Settings -> Configurations -> API Keys. Off until the backend says otherwise: a customer
  // without the flag must not see the screen, and an unknown key here reads as undefined, which
  // would be falsy anyway but would not show up in this list as something that exists.
  apiKeys: false,
  websiteVisitorDashboard: false,
  websiteAccountList: false,
  campaignDashboard: false,
  showOpportunities: false,
  hubspot: false,
  zoho: false,
  freshsales: false,
  salesforce: false,
  pipedrive: false,
  icpScoring: false,
  chatbot: false,
  awardsAndRecognition: false,
  recentFunding: false,
  aiNews: false,
  outreach: false,
  microsoft: false,
  salesloft: false,
  gong: false,
  instantly: false,
  mailchimp: false,
  heyreach: false,
  lemlist: false,
  intercom: false,
  // Intercom Messenger (support widget) - separate from Intercom Integration/CMP
  intercomMessenger: false,
  pardot: false,
  gmail: false,
  googledrive: false,
  googleslides: false,
  googledocs: false,
  smartlead: false,
  slack: false,
  amplitude: false,
  segment: false,
  mixpanel: false,
  g2crowd: false,
  trustradius: false,
  googleanalytics: false,
  swarm: false,
  teams: false,
  outlook: false,
  sendgrid: false,
  pendo: false,
  adobemarketo: false,
  similarweb: false,
  semrush: false,
  mockIntegration: false,
  automated_playbook: false,
  g2_enabled: false,
  contactReveal: false,
  customAiSignals: false,
  jobOpening: false,
  multiChild: false,
  hybridCustomIcp: false,
  realTimeIcp: false,
  jobChangeAlert: false,
  hybridCustomWeightageIcp: false,
  dummyDomain: false,
  championTracking: false,
  displayLeadSync: false,
  validateEmail: false,
  validatePhoneNumber: false,
  hpmCustomConfiguration: false,
  hpmManualIcp: false,
  moveToTalOverKafka: false,
  newPlaybook: false,
  selfRecharge: false,
  enrichmentByNameLinkedin: false,
  conversationalPlaybook: false,
  accountIntelligence: false,
  realTimeDataRefresh: false,
  askAi2: false,
  salesNavImport: false,
  linkedinFakeProfileValidation: false,
  userLevelCredit: false,
  notifications: undefined,
  discoverAndRefresh: false,
  tomatoDeepChunking: false,
  customFieldExtension: false,
  domainFiltering: false,
  headcountCapsicumEnrichment: false
};

export const customersForLLm = [
  '1b7a366e76329297d60921937c194adb', // Sprouts.ai from Prod
];

export const LlmEmails: Record<number, Record<string, any>> = {
  // for QA
  952458: {
    // Matthew Dellenger
    'AI News': {
      email: [
        ` Congrats on OneStream Software's recent launch of Sensible, an AI suite aimed at finance leaders. I can imagine the impact it's already having on finance operations.`,
        `Similar to Sensible, we have built an AI-powered GTM intelligence platform. As VP of Sales, South, I'm sure you're always looking for ways to optimize your sales strategy. Sprouts.ai can help you identify high-intent leads, prioritize outreach, and maximize conversions. In fact, our clients have seen a 20% increase in SQLs and 30% reduction in reporting time.`,
        `Would love to explore how Sprouts.ai can help OneStream Software's sales team. Can we schedule a quick call this week?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Maximize Sales Efficiency with AI-Powered Insights at OneStream`,
      createdAt: '12-10-2023 13:41:06',
    },
    'Awards and Recognition': {
      email: [
        `Congrats on winning the 2024 Finance Transformation Award. We at Sprouts.AI are able to mine for awards and multiple other AI powered custom signals for personalized reachout. As VP of Sales, South, I'm sure you're always looking for innovative solutions to drive growth.`,
        `Sprouts.ai can help you optimize your sales strategy with AI-based ICP creation and scoring, and 1st party & 3rd party account level intent. Our clients have seen a 20% increase in SQLs to Closed Won and 30% less time spent on reporting.`,
        `Would love to discuss how Sprouts.ai can help OneStream Software accelerate its growth. Can we schedule a quick call this week?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Drive Growth at OneStream with AI-Powered Sales Strategies`,
      createdAt: '12-10-2023 13:41:06',
    },
    'High Website Visitor': {
      email: [
        `I'm Karan, CEO & Co-founder at Sprouts.AI. My team noticed your website attracts over 70,150 visitors monthly. Typically, less than 2% of website visitors sign-up for demos, which means you should be receiving less than 1500 demos/month currently.`,
        `Sprouts.AI platform can help you identify 15,000+ anonymous visitors, qualify them against your ICP, measure their intent based on pages they visited, and run targeted campaigns on qualified prospects to generate qualified pipeline.`,
        `Can we schedule a quick call to discuss how Sprouts.AI can help you leverage your website traffic more effectively? Looking forward to your response.`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Boost Lead Generation from 70K+ Visitors with AI`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  // for prod
  1033967: {
    // Matthew Dellenger
    'AI News': {
      email: [
        ` Congrats on OneStream Software's recent launch of Sensible, an AI suite aimed at finance leaders. I can imagine the impact it's already having on finance operations.`,
        `Similar to Sensible, we have built an AI-powered GTM intelligence platform. As VP of Sales, South, I'm sure you're always looking for ways to optimize your sales strategy. Sprouts.ai can help you identify high-intent leads, prioritize outreach, and maximize conversions. In fact, our clients have seen a 20% increase in SQLs and 30% reduction in reporting time.`,
        `Would love to explore how Sprouts.ai can help OneStream Software's sales team. Can we schedule a quick call this week?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Maximize Sales Efficiency with AI-Powered Insights at OneStream`,
      createdAt: '12-10-2023 13:41:06',
    },
    'Awards and Recognition': {
      email: [
        `Congrats on winning the 2024 Finance Transformation Award. We at Sprouts.AI are able to mine for awards and multiple other AI powered custom signals for personalized reachout. As VP of Sales, South, I'm sure you're always looking for innovative solutions to drive growth.`,
        `Sprouts.ai can help you optimize your sales strategy with AI-based ICP creation and scoring, and 1st party & 3rd party account level intent. Our clients have seen a 20% increase in SQLs to Closed Won and 30% less time spent on reporting.`,
        `Would love to discuss how Sprouts.ai can help OneStream Software accelerate its growth. Can we schedule a quick call this week?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Drive Growth at OneStream with AI-Powered Sales Strategies`,
      createdAt: '12-10-2023 13:41:06',
    },
    'High Website Visitor': {
      email: [
        `I'm Karan, CEO & Co-founder at Sprouts.AI. My team noticed your website attracts over 70,150 visitors monthly. Typically, less than 2% of website visitors sign-up for demos, which means you should be receiving less than 1500 demos/month currently.`,
        `Sprouts.AI platform can help you identify 15,000+ anonymous visitors, qualify them against your ICP, measure their intent based on pages they visited, and run targeted campaigns on qualified prospects to generate qualified pipeline.`,
        `Can we schedule a quick call to discuss how Sprouts.AI can help you leverage your website traffic more effectively? Looking forward to your response.`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Boost Lead Generation from 70K+ Visitors with AI`,
      createdAt: '12-10-2023 13:41:06',
    },
    'Company Growth': {
      email: [
        `I noticed we have several mutual connections. Congrats on OneStream's growth, especially the 10% increase in the last 6 months. `,
        `We are building a GTM intelligence platform to make SDRs 5X more efficient while increasing sales conversion rates and reducing overall martech tool costs. Our current customers have seen a 30%+ increase in SQLs and 25%+ reduction in tool costs.  `,
        `Would love to get your thoughts on our platform and see if it can be helpful in accelerating your growth. Let me know if can schedule a quick call.`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Exploring Synergies: Enhancing Sales Efficiency with GTM Intelligence`,
      createdAt: '12-10-2023 13:41:06',
    },
    'ICP Variables': {
      email: [
        `As a VP of Sales, I'm sure you're constantly looking for ways to accelerate growth. I came across your profile and noticed you're leading the sales efforts for OneStream Software in the South region. Good stuff!`,
        `We are building a GTM intelligence platform to make SDRs 5X more efficient while increasing sales conversion rates and reducing overall martech tool costs. Our current customers have seen a 30%+ increase in SQLs and 25%+ reduction in tool costs.`,
        `Would you be open to a quick call to discuss how Sprouts.ai can help OneStream Software accelerate sales growth?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Enhance Sales Efficiency with Sprouts.ai: Let's Discuss`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  1033968: {
    // Mark Reed
    'AI News': {
      email: [
        `I came across your profile and noticed OneStream Software's innovative approach to Corporate Performance Management. I'm impressed by the launch of Sensible, the AI suite aimed at finance leaders. As VP Sales - West, I'm sure you're always looking for ways to optimize your sales strategy.`,
        `Our AI-powered platform, Sprouts.ai, can help you identify high-intent leads and prioritize outreach for better conversions. With our solution, companies have seen a 20% increase in SQLs and a 30% reduction in time spent on reporting.
`,
        `Would you be open to a quick call to explore how Sprouts.ai can support your sales efforts?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Optimize Your Sales Strategy with AI-Powered Insights from Sprouts.ai`,
      createdAt: '12-10-2023 13:41:06',
    },
    'Awards and Recognition': {
      email: [
        `I came across your profile and noticed that OneStream Software has been recognized for its strong performance and leadership in enterprise finance platforms. Congratulations on that achievement! As the VP of Sales - West, I'm sure you're always looking for ways to optimize your sales strategy and stay ahead of the competition.`,
        `That's where Sprouts.ai comes in - our AI-powered GTM intelligence platform helps companies like OneStream Software build comprehensive outbound strategies, analyze and improve conversion rates, and reduce marketing expenses. With our platform, you could see a 20% increase in SQLs and a 30% reduction in time spent on reporting.`,
        `Would you be open to a quick call to discuss how Sprouts.ai can help OneStream Software further accelerate its growth?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Boost OneStream's Sales with AI-Powered GTM Intelligence`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  184847: {
    // Divyesh Kharade
    'Hiring SDR/BDR': {
      email: [
        `I noticed DronaHQ is actively hiring SDRs. Would you like to move towards a leaner team size and still hit your revenue targets? `,
        `At Sprouts.AI, we make SDRs 5X more efficient by automating a lot of their tasks including Account ICP score, account research and measuring intent. We are generating over 50+ custom AI signals for personalized outreach. That means you might not need to hire the extra SDRs in your plan. Moreover, our current customers have seen sales qualified pipeline increase by 30%+ while saving 25%+ on their martech tool cost. `,
        `Can we schedule a quick call to discuss this further?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Optimize SDR Efficiency with Sprouts.AI`,
      createdAt: '12-10-2023 13:41:06',
    },
    'ICP Variables': {
      email: [
        `I came across your profile and noticed how you're disrupting the app development space with DronaHQ's low-code platform. As a fellow entrepreneur, I appreciate the effort that goes into building a platform that enables companies to build complex business apps without writing code.`,
        `We are building a GTM intelligence platform to make SDRs 5X more efficient. I saw that you are using Hubspot, 80%+ of our current customers use our bi-directional Hubspot sync and have seen a 30%+ increase in SQLs and 25%+ reduction in tool costs.`,
        `Let me know if we can get on a quick call to explore how Sprouts.AI can help DronaHQ optimize their demand generation process.`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Maximize DronaHQ's HubSpot Integration for Growth`,
      createdAt: '12-10-2023 13:41:06',
    },
    'High Website Visit': {
      email: [
        `I'm Karan, CEO & Co-founder at Sprouts.AI. My team noticed your website attracts over 19,900 visitors monthly. Typically, less than 2% of website visitors sign-up for demos, which means you should be receiving less than 400 demos/month currently. `,
        `Sprouts.AI platform can help you identify 6,000+ anonymous visitors, qualify them against your ICP, measure their intent based on pages they visited, and run targeted campaigns on qualified prospects to generate qualified pipeline.`,
        `Can we schedule a quick call to discuss how Sprouts.AI can help you leverage your website traffic more effectively? Looking forward to your response.`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Enhance Lead Generation from Your Website: Let's Talk, Divyesh`,
      createdAt: '12-10-2023 13:41:06',
    },
    '1st Degree connection': {
      email: [
        `How are things? We have been making great progress at Sprouts.AI - Launched a lot of AI signals to further automate B2B GTM workflows. Revenue is growing fast and our current customers have seen a 30%+ increase in SQLs and 25%+ reduction in tool costs.`,
        `Would love to show you what we are building and see if there is an opportunity to work together. `,
        `Let me know your availability for a call this week.`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Update from Sprouts.AI: Enhance B2B GTM with AI Signals`,
      createdAt: '12-10-2023 13:41:06',
    },
    'Recent Website Visit - BOFU': {
      email: [
        `I'm Karan, Co-Founder and CEO of Sprouts.ai, and thought of dropping you a note to discuss the GTM of DronaHQ. `,
        `As a fellow CEO, I understand the importance of targeted outreach and maximizing revenue. Our AI-powered GTM intelligence platform helps companies like yours identify high-intent leads, prioritize outreach, and automate engagement. This results in 30%+ more SQLs and 25%+ reduction in Martech tool costs.`,
        `Would you be open to a quick call to discuss how Sprouts.ai can help DronaHQ accelerate growth?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Explore Growth Opportunities for DronaHQ with Sprouts.ai`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  769378: {
    // Maria Conchita
    'AI News': {
      email: [
        `I came across Epic's initiative to democratize health AI validation and was impressed by the impact it can have on standardizing AI applications in healthcare. As a Marketing Director, I'm sure you're always looking for innovative ways to generate leads and fill your sales pipeline.`,
        `With Sprouts.ai, we've helped companies like yours generate 20% more SQLs and reduce reporting time by 30%. Our AI-based ICP creation and scoring can help you target the right audience and maximize your outbound efforts.`,
        `Would love to discuss how Sprouts.ai can support Epic's growth initiatives. Can we schedule a quick call this week?
  `,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Boost Epic's Lead Generation with AI-Powered Marketing Solutions`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  769856: {
    // Rick Walter
    'AI News': {
      email: [
        `I came across EPIC's initiative to democratize health AI validation and was impressed by the impact it can have on standardizing AI applications in healthcare. As a VP of Marketing, I'm sure you're always looking for innovative ways to generate leads and improve conversion rates.`,
        `Sprouts.ai can help EPIC enhance its marketing strategy with AI-based ICP creation and scoring, 1st party & 3rd party account level intent, and an all-in-one platform for all GTM needs. This can result in 20% more SQLs to Closed Won and 30% less time spent on reporting.
  `,
        `Would love to discuss how Sprouts.ai can support EPIC's growth initiatives over a quick call. Are you available this week?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Enhance EPIC's Marketing Strategy with AI-Powered Solutions`,
      createdAt: '12-10-2023 13:41:06',
    },
    'Awards and Recognition': {
      email: [
        `I came across EPIC's recent recognition with the BrandLaureate Nation Branding Award and Lifetime Achievement Awards. Congratulations on this impressive achievement! As a fellow leader in the industry, I understand the importance of building a strong brand and driving growth.
  `,
        `As the Co-Founder and CEO of Sprouts.ai, I've helped companies like yours improve their outbound strategy, increasing conversions by 20% and reducing marketing expenses by 30%. Our AI-powered ICP creation and scoring, along with 1st party & 3rd party account level intent, can help EPIC optimize its marketing efforts.
  `,
        `Would you be open to a quick call to explore how Sprouts.ai can support EPIC's growth initiatives?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Congratulations! Let's Discuss Enhancing EPIC's Growth with AI Solutions`,
      createdAt: '12-10-2023 13:41:06',
    },
    'MH - ': {
      email: [
        `I came across your profile and noticed you're a V.P. Marketing at EPIC. As someone who's passionate about building great GTM strategies, I was intrigued by your role.
  `,
        `At Sprouts.ai, we help companies like EPIC boost their revenue by 20% and reduce marketing expenses. Our AI-based ICP creation and scoring enables focused targeting, and our all-in-one platform streamlines GTM needs.
  `,
        `Can we discuss how Sprouts.ai can help EPIC achieve similar results? I'd love to set up a quick call to explore this further.
  `,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Boost EPIC's Revenue with AI-Powered Marketing Strategies`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  158112: {
    // Shashank Bijapur
    'Hiring for SDRs/BDRs': {
      email: [
        `As a fellow Co-Founder & CEO, I understand the importance of building a comprehensive outbound strategy for B2B lead generation. I came across SpotDraft and was impressed with your vision.
`,
        `At Sprouts.ai, we help companies like yours analyze and improve conversion rates in the B2B customer journey, reducing marketing expenses. Our AI-based ICP creation and scoring enables focused targeting, and our all-in-one platform streamlines GTM needs.
`,
        `Would you be open to a quick call to explore how Sprouts.ai can help SpotDraft optimize its sales pipeline and reduce marketing expenses?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Optimize SpotDraft's B2B Lead Generation with AI`,
      createdAt: '12-10-2023 13:41:06',
    },
    'MH - ': {
      email: [
        `As a fellow Co-Founder & CEO, I understand the importance of maximizing revenue and ROI. I came across SpotDraft and was impressed with your entrepreneurial spirit.
`,
        `Sprouts.ai can help you increase revenue by 20% and reduce marketing expenses by 30%. Our AI-powered GTM intelligence platform helps businesses like yours optimize their outbound strategy and improve conversion rates.
`,
        `Would love to discuss how Sprouts.ai can help SpotDraft achieve similar results. Can we schedule a quick call this week?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Maximize Revenue and Reduce Expenses with AI at SpotDraft`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  465102: {
    // Pranav Nair
    'Hiring for SDRs/BDRs': {
      email: [
        `I noticed that Spotdraft is currently expanding and actively hiring for its SDR team, which reflects a strong growth trajectory for your company. At Sprouts.ai, we are building innovative solutions that might be beneficial for your current expansion
`,
        `At Sprouts.ai, we've helped companies like Spotdraft automate contract setups and optimise their GTM strategies. Our AI-based ICP creation and scoring, along with intent data, can enhance the efficiency of your current SDR team by focusing on high-intent leads, reducing marketing expenses, and increasing conversions by 20%.
`,
        `I'd love to discuss how Sprouts.ai can support Spotdraft's growth initiatives. Can we schedule a quick call to explore this further?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Enhance SpotDraft's GTM Strategy with AI Solutions`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  944822: {
    // Dr. Smbat Rafayelyan
    'Recent Funding': {
      email: [
        `I came across your profile and was impressed with BioNeex's innovative approach to the biopharma industry. Congratulations on the recent seed funding of $500K! As a fellow entrepreneur, I understand the importance of strategic growth initiatives.
`,
        `As the Co-Founder and CEO of Sprouts.ai, I help companies like BioNeex develop a comprehensive outbound strategy for B2B lead generation, analyze and improve conversion rates, and reduce marketing expenses. Our AI-powered platform can help you identify high-intent leads, deanonymize website visitors, and prioritize outreach for better conversions.
`,
        `Would you be open to a quick call to discuss how Sprouts.ai can support BioNeex's growth?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `RSupport BioNeex's Growth with AI-Powered Outbound Strategy`,
      createdAt: '12-10-2023 13:41:06',
    },
    'MH - ': {
      email: [
        `I came across your profile and was impressed with BioNeex's innovative approach to facilitating partnership deals in the biopharma industry. As a fellow entrepreneur, I understand the importance of strategic growth initiatives.
`,
        `At Sprouts.ai, we help companies like BioNeex increase their revenue by 20% and reduce marketing expenses by 30%. Our AI-powered GTM intelligence platform enables targeted outreach, resulting in higher conversion rates.
`,
        `Would you be open to a quick call to explore how Sprouts.ai can support BioNeex's growth strategy?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Accelerate BioNeex's Growth with AI-Powered GTM Intelligence`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  288307: {
    // Piyush Keshari
    'Hiring for SDRs/BDRs': {
      email: [
        `I came across your profile and was impressed with your work in marketing operations and analytics at Monotype. Your ability to create a Marketing KPI dashboard to measure campaign-wise ROI and integrate various sources of marketing and revenue data is truly commendable.
`,
        `As a Manager of Marketing Operations & Analytics, I understand you face challenges in generating leads and filling the sales pipeline. Sprouts.ai can help you with AI-based ICP creation and scoring for focused targeting, all-in-one platform for all marketing needs, and LLM generated hyper-personalized messages. This can result in 20% more SQLs to Closed Won, 30% less time spent on reporting, and 70% less time spent on drafting emails with 40% more replies.
`,
        `Would you be open to a quick call to discuss how Sprouts.ai can help Monotype's marketing operations?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Boost Monotype's Marketing Operations with AI Insights`,
      createdAt: '12-10-2023 13:41:06',
    },
    'Awards and Recognition': {
      email: [
        `I came across your profile and was impressed with your work in marketing operations and analytics at Monotype. Your ability to create a Marketing KPI dashboard to measure campaign-wise ROI and integrating various sources of marketing and revenue data together in a single warehouse is truly commendable.
`,
        `As someone who has championed the integration of marketing attribution tools, I think you'll appreciate how Sprouts.ai can help you generate 20% more SQLs and reduce reporting time by 30%. Our AI-based ICP creation and scoring can help you focus on high-intent leads and maximize engagement.
`,
        `Would love to discuss how Sprouts.ai can help Monotype's marketing efforts, especially with their recent expansion and creative partnerships. Can we schedule a quick call this week?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Enhance Monotype's Lead Generation with AI Solutions`,
      createdAt: '12-10-2023 13:41:06',
    },
    'MH - ': {
      email: [
        `I came across your profile and was impressed with your work in marketing operations and analytics at Monotype. Your ability to create a Marketing KPI dashboard to measure campaign-wise ROI and integrate various sources of marketing and revenue data is truly commendable.
`,
        `As someone who's worked on streamlining marketing operations, I think you'll appreciate how Sprouts.ai can help automate and optimize your workflows. With our AI-based ICP creation and scoring, you can focus on high-intent leads and reduce manual efforts. We've seen companies reduce their FTE count by 30% and increase their sales pipeline by 20%. 
`,
        `Would love to discuss how Sprouts.ai can help Monotype's marketing operations. Can we schedule a quick call this week?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Optimize Monotype's Marketing Workflows with AI`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  947395: {
    // Chris Churilo
    'LinkedIn connection': {
      email: [
        `I came across your profile and noticed that you're leading the marketing efforts at Zilliz, the creators of Milvus, the world's most popular open-source vector database. As a fellow leader in the tech space, I'm impressed by your work in the AI-powered database industry.
`,
        `As a VP of Marketing, I understand you might be facing challenges in developing a comprehensive outbound strategy for B2B lead generation and analyzing conversion rates in the customer journey. Sprouts.ai can help you overcome these challenges with our AI-based ICP creation and scoring for focused targeting, 1st party & 3rd party account level intent, and an all-in-one platform for all GTM needs, resulting in 20% more SQLs to Closed Won and 30% less time spent on reporting.
`,
        `Would love to discuss how Sprouts.ai can help Zilliz achieve its marketing goals. Can we schedule a quick call to explore this further?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Enhance Zilliz's Marketing Strategy with AI-Powered Insights`,
      createdAt: '12-10-2023 13:41:06',
    },
    'MH - ': {
      email: [
        `I came across your profile and noticed that you're leading the marketing efforts at Zilliz, the creators of Milvus, the world's most popular open-source vector database. As someone who's passionate about building great GTM strategies, I was intrigued by your work.
`,
        `As a VP of Marketing, you might be facing challenges in developing a comprehensive outbound strategy for B2B lead generation and analyzing conversion rates in the B2B customer journey. Our AI-powered GTM intelligence platform can help you overcome these challenges, resulting in 20% more SQLs to Closed Won and 30% less time spent on reporting.
`,
        `Would you be open to a quick call to discuss how Sprouts.ai can help Zilliz achieve its marketing goals?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Optimize Zilliz's B2B Lead Generation with AI Solutions`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  158645: {
    // Faisal Shah
    Generic: {
      email: [
        `II noticed your impactful work in mobile and online brand protection and enforcement at Tracer. As a fellow entrepreneur, I admire the dedication it takes to build a brand from the ground up.`,
        `At Sprouts.ai, we specialize in empowering companies like yours with advanced AI tools for B2B lead generation. Our platform offers AI-based ICP creation, precise targeting through 1st and 3rd party account-level intent data, and a comprehensive GTM solution—all aimed at driving a 20% increase in SQLs and streamlining reporting by 30%.`,
        `Could we schedule a quick call to explore how Sprouts.ai can support Tracer in achieving its growth objectives?`,
        `Looking forward to your response.`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Exploring Collaboration: Enhancing Tracer's Outbound Strategy`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  152713: {
    // Nate Carter
    Generic: {
      email: [
        `I've been following your impactful work in establishing a Center of Excellence at Chargebee. I'm Karan Chaudhry, Co-Founder and CEO of Sprouts.ai, where we're pioneering AI-driven B2B GTM strategies.`,
        `Our platform enhances conversion rates by 20% and reduces marketing expenses by 30% through AI-powered ICP creation, account-level intent insights, and a comprehensive GTM solution.`,
        `I'd like to explore how Sprouts.ai can support Chargebee's revenue operations. Could we schedule a brief call this week to discuss further?`,
        `Looking forward to connecting.`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Exploring Growth Strategies for Chargebee with Sprouts.ai`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  153024: {
    // Rishi Bhargava
    Generic: {
      email: [
        `I noticed your expertise in innovative product management and go-to-market strategies at Descope. As someone focused on exponential growth, I'm intrigued by your emphasis on leveraging customer identity.`,
        `At Sprouts.ai, we specialize in enhancing outbound strategies, boosting conversion rates, and optimizing marketing expenses with AI-based ICP creation and scoring.`,
        `I'm keen to discuss how Sprouts.ai can help Descope achieve its growth goals. Could we schedule a quick call to explore synergies?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Collaboration Opportunity: Optimizing GTM for Descope`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  244891: {
    // Charles Goforth
    Generic: {
      email: [
        `I noticed your strong background in optimizing IT delivery services, especially in cloud architecture and data solutions with a security focus. As Director of Sales Engineering at Clumio, I'm sure you're focused on enhancing your sales pipeline efficiency.`,
        `At Sprouts.ai, our AI-powered GTM intelligence platform excels in identifying high-intent leads, prioritizing personalized outreach, and boosting conversion rates by up to 20%.`,
        `I'm keen to discuss how Sprouts.ai can specifically support Clumio's sales strategy. Would you be available for a quick call to explore this further?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Optimizing Sales Strategy for Clumio with Sprouts.ai`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  184848: {
    // Nathalie Simond
    Generic: {
      email: [
        `I admire your entrepreneurial spirit and the innovative work at Amadeus. I'm Karan Chaudhry, Co-Founder and CEO of Sprouts.ai, a B2B GTM Intelligence platform.`,
        `Sprouts.ai specializes in developing comprehensive outbound strategies, optimizing conversion rates, and reducing marketing expenses. Our AI-based ICP creation and scoring ensures precise targeting, supported by an all-in-one platform for streamlined GTM operations.`,
        `I would like to discuss how Sprouts.ai can benefit Amadeus. Could we schedule a quick call to explore this opportunity further?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Exploring Growth Opportunities for Amadeus with Sprouts.ai`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  157508: {
    // Tim Beck
    Generic: {
      email: [
        `I've been following Valli Information Systems and am impressed by your leadership in driving the company's growth. As a fellow CEO, I understand the critical importance of developing a strategic outbound approach for sustained B2B lead generation success.`,
        `At Sprouts.ai, we specialize in optimizing B2B customer journey conversion rates and reducing marketing expenses by up to 30%. Our AI-driven ICP creation and scoring enable precise targeting, supported by a comprehensive platform tailored to streamline GTM processes.`,
        `I'm keen to discuss how Sprouts.ai can specifically benefit Valli Information Systems. Could we schedule a brief call this week to explore this opportunity further?`,
        `Looking forward to your response.`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Enhancing Valli Information Systems' Growth Strategy with Sprouts.ai`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  158513: {
    // Ian Adams
    Generic: {
      email: [
        `I admire Revenue Collective's mission to unite sales and marketing executives around growth. As a fellow advocate for exponential growth, I'm impressed by your community's dedication.`,
        `Sprouts.ai specializes in optimizing GTM strategies, achieving a 20% increase in conversions and reducing marketing expenses. Our AI-driven ICP creation and scoring ensures precise targeting, supported by a comprehensive all-in-one platform.`,
        `I'd like to discuss how Sprouts.ai can benefit the Revenue Collective. Could we schedule a quick call to explore this further?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Enhancing Revenue Collective's GTM Strategy with Sprouts.ai`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  279302: {
    // Lucas Hathaway
    Generic: {
      email: [
        `I noticed your role as Chief Revenue Officer at Rivial Data Security. I'm Karan Chaudhry, Co-Founder and CEO of Sprouts.ai, where we've developed an AI-powered B2B GTM intelligence platform.`,
        `As a CRO, refining outbound strategies for B2B lead generation and improving conversion rates are crucial. Sprouts.ai can help achieve a 20% increase in SQLs to Closed Won and reduce marketing expenses.`,
        `I'd like to discuss how Sprouts.ai can assist Rivial Data Security in overcoming these challenges. Could we schedule a brief call this week to explore further?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Optimizing B2B Lead Generation Strategy at Rivial Data Security`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  158666: {
    // Lynne Riojas
    Generic: {
      email: [
        `I noticed your leadership at Captiv8, particularly in heading the sales team within the SaaS sector. Given your experience, I understand the challenges of developing a robust outbound strategy for B2B lead generation.`,
        `At Sprouts.ai, our AI-powered platform has helped companies achieve a 20% increase in SQLs and reduce reporting time by 30%. I'm interested in discussing how we can help Captiv8 achieve similar success.`,
        `Could we schedule a quick call to discuss further this week?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Enhancing B2B Lead Generation Strategy at Captiv8 with Sprouts.ai`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
  287998: {
    // Anna Smazylo
    Generic: {
      email: [
        `I noticed your impressive background in B2C and B2B telesales. Given your expertise in building relationships and closing deals over the phone, you understand the importance of targeted outreach.`,
        `At Sprouts.ai, we specialize in helping companies like Pursuit Marketing enhance their sales pipeline by up to 20% through AI-based ICP creation, scoring, and advanced intent insights.`,
        `I would like to discuss how Sprouts.ai can specifically benefit Pursuit Marketing's sales team. Could we schedule a quick call to explore this further?`,
        `Thanks,`,
        `Karan Chaudhry`,
      ],
      subject: `Optimizing Sales Pipeline at Pursuit Marketing with Sprouts.ai`,
      createdAt: '12-10-2023 13:41:06',
    },
  },
};

export const hideContactsColumnListForSproutsAI: string[] = [
  'Source',
  'Source file',
  'Campaign Stage',
  'Verified Email',
  'Account Lifecycle Stage',
  'Account Status',
  'Prospect Lifecycle Stage',
  'Contact Owner',
  'Account Owner',
  'Prospect Work Phone',
  'HQ Phone Number',
];
export const hideAccountsColumnListForSproutsAI: string[] = [
  'Account Lifecycle Stage',
  'Account Status',
  'Account Owner',
  'HQ Phone Number',
];

export const AIICP = 'Sprouts recommended ICP';

export const excludedICPContactFilters = [
  'Job Title',
  'Department',
  'Designation',
  'Employee by department',
  'Founded year',
  'Job opening',
];

export const includedFiltersForAutoQualification = ['Job Title', 'Department', 'Designation'];

export const exclusionTypes = [
  { value: 'activeCustomer', label: 'Active Customer' },
  { value: 'churnedCustomer', label: 'Churned Customer' },
  { value: 'competitor', label: 'Competitor' },
  { value: 'partner', label: 'Partner' },
  { value: 'sisterCompany', label: 'Sister Company' },
  { value: 'others', label: 'Others' },
];

interface CountryType {
  code: string;
  name: string;
  suggested?: boolean;
}

export const countriesWithCode: CountryType[] = [
  { code: 'AD', name: 'Andorra' },
  {
    code: 'AE',
    name: 'United Arab Emirates',
  },
  { code: 'AF', name: 'Afghanistan' },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
  },
  { code: 'AI', name: 'Anguilla' },
  { code: 'AL', name: 'Albania' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AO', name: 'Angola' },
  { code: 'AQ', name: 'Antarctica' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AS', name: 'American Samoa' },
  { code: 'AT', name: 'Austria' },
  {
    code: 'AU',
    name: 'Australia',

    suggested: true,
  },
  { code: 'AW', name: 'Aruba' },
  { code: 'AX', name: 'Alland Islands' },
  { code: 'AZ', name: 'Azerbaijan' },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  { code: 'BB', name: 'Barbados' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BI', name: 'Burundi' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BL', name: 'Saint Barthelemy' },
  { code: 'BM', name: 'Bermuda' },
  { code: 'BN', name: 'Brunei Darussalam' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BR', name: 'Brazil' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BV', name: 'Bouvet Island' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BZ', name: 'Belize' },
  {
    code: 'CA',
    name: 'Canada',
    suggested: true,
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    code: 'CD',
    name: 'Congo, Democratic Republic of the',
  },
  {
    code: 'CF',
    name: 'Central African Republic',
  },
  {
    code: 'CG',
    name: 'Congo, Republic of the',
  },
  { code: 'CH', name: 'Switzerland' },
  { code: 'CI', name: "Cote d'Ivoire" },
  { code: 'CK', name: 'Cook Islands' },
  { code: 'CL', name: 'Chile' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CV', name: 'Cape Verde' },
  { code: 'CW', name: 'Curacao' },
  { code: 'CX', name: 'Christmas Island' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  {
    code: 'DE',
    name: 'Germany',

    suggested: true,
  },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'DK', name: 'Denmark' },
  { code: 'DM', name: 'Dominica' },
  {
    code: 'DO',
    name: 'Dominican Republic',
  },
  { code: 'DZ', name: 'Algeria' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EE', name: 'Estonia' },
  { code: 'EG', name: 'Egypt' },
  { code: 'EH', name: 'Western Sahara' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'ES', name: 'Spain' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'FI', name: 'Finland' },
  { code: 'FJ', name: 'Fiji' },
  {
    code: 'FK',
    name: 'Falkland Islands (Malvinas)',
  },
  {
    code: 'FM',
    name: 'Micronesia, Federated States of',
  },
  { code: 'FO', name: 'Faroe Islands' },
  {
    code: 'FR',
    name: 'France',

    suggested: true,
  },
  { code: 'GA', name: 'Gabon' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GE', name: 'Georgia' },
  { code: 'GF', name: 'French Guiana' },
  { code: 'GG', name: 'Guernsey' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GI', name: 'Gibraltar' },
  { code: 'GL', name: 'Greenland' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GP', name: 'Guadeloupe' },
  { code: 'GQ', name: 'Equatorial Guinea' },
  { code: 'GR', name: 'Greece' },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
  },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GU', name: 'Guam' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HK', name: 'Hong Kong' },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  { code: 'HN', name: 'Honduras' },
  { code: 'HR', name: 'Croatia' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HU', name: 'Hungary' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IM', name: 'Isle of Man' },
  { code: 'IN', name: 'India' },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
  },
  { code: 'IQ', name: 'Iraq' },
  {
    code: 'IR',
    name: 'Iran, Islamic Republic of',
  },
  { code: 'IS', name: 'Iceland' },
  { code: 'IT', name: 'Italy' },
  { code: 'JE', name: 'Jersey' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JO', name: 'Jordan' },
  {
    code: 'JP',
    name: 'Japan',

    suggested: true,
  },
  { code: 'KE', name: 'Kenya' },
  { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KM', name: 'Comoros' },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    code: 'KP',
    name: "Korea, Democratic People's Republic of",
  },
  { code: 'KR', name: 'Korea, Republic of' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KY', name: 'Cayman Islands' },
  { code: 'KZ', name: 'Kazakhstan' },
  {
    code: 'LA',
    name: "Lao People's Democratic Republic",
  },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LY', name: 'Libya' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MC', name: 'Monaco' },
  {
    code: 'MD',
    name: 'Moldova, Republic of',
  },
  { code: 'ME', name: 'Montenegro' },
  {
    code: 'MF',
    name: 'Saint Martin (French part)',
  },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MH', name: 'Marshall Islands' },
  {
    code: 'MK',
    name: 'Macedonia, the Former Yugoslav Republic of',
  },
  { code: 'ML', name: 'Mali' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'MO', name: 'Macao' },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
  },
  { code: 'MQ', name: 'Martinique' },
  { code: 'MR', name: 'Mauritania' },
  { code: 'MS', name: 'Montserrat' },
  { code: 'MT', name: 'Malta' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'MV', name: 'Maldives' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MX', name: 'Mexico' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NC', name: 'New Caledonia' },
  { code: 'NE', name: 'Niger' },
  { code: 'NF', name: 'Norfolk Island' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NO', name: 'Norway' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NU', name: 'Niue' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'OM', name: 'Oman' },
  { code: 'PA', name: 'Panama' },
  { code: 'PE', name: 'Peru' },
  { code: 'PF', name: 'French Polynesia' },
  { code: 'PG', name: 'Papua New Guinea' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PL', name: 'Poland' },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  { code: 'PN', name: 'Pitcairn' },
  { code: 'PR', name: 'Puerto Rico' },
  {
    code: 'PS',
    name: 'Palestine, State of',
  },
  { code: 'PT', name: 'Portugal' },
  { code: 'PW', name: 'Palau' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RE', name: 'Reunion' },
  { code: 'RO', name: 'Romania' },
  { code: 'RS', name: 'Serbia' },
  { code: 'RU', name: 'Russian Federation' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SB', name: 'Solomon Islands' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SD', name: 'Sudan' },
  { code: 'SE', name: 'Sweden' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SH', name: 'Saint Helena' },
  { code: 'SI', name: 'Slovenia' },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
  },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SM', name: 'San Marino' },
  { code: 'SN', name: 'Senegal' },
  { code: 'SO', name: 'Somalia' },
  { code: 'SR', name: 'Suriname' },
  { code: 'SS', name: 'South Sudan' },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
  },
  { code: 'SV', name: 'El Salvador' },
  {
    code: 'SX',
    name: 'Sint Maarten (Dutch part)',
  },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
  },
  { code: 'SZ', name: 'Swaziland' },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
  },
  { code: 'TD', name: 'Chad' },
  {
    code: 'TF',
    name: 'French Southern Territories',
  },
  { code: 'TG', name: 'Togo' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TJ', name: 'Tajikistan' },
  { code: 'TK', name: 'Tokelau' },
  { code: 'TL', name: 'Timor-Leste' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TR', name: 'Turkey' },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
  },
  { code: 'TV', name: 'Tuvalu' },
  {
    code: 'TW',
    name: 'Taiwan',
  },
  {
    code: 'TZ',
    name: 'United Republic of Tanzania',
  },
  { code: 'UA', name: 'Ukraine' },
  { code: 'UG', name: 'Uganda' },
  {
    code: 'US',
    name: 'United States',
    suggested: true,
  },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  {
    code: 'VA',
    name: 'Holy See (Vatican City State)',
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  { code: 'VE', name: 'Venezuela' },
  {
    code: 'VG',
    name: 'British Virgin Islands',
  },
  {
    code: 'VI',
    name: 'US Virgin Islands',
  },
  { code: 'VN', name: 'Vietnam' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'WF', name: 'Wallis and Futuna' },
  { code: 'WS', name: 'Samoa' },
  { code: 'XK', name: 'Kosovo' },
  { code: 'YE', name: 'Yemen' },
  { code: 'YT', name: 'Mayotte' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' },
];

export const formatTimeIntoHhMmSs = (ms: number) => {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours) {
    return `${String(hours).padStart(2, '0')}h:${String(minutes).padStart(2, '0')}m:${String(
      seconds,
    ).padStart(2, '0')}s`;
  }

  return `${String(minutes).padStart(2, '0')}m:${String(seconds).padStart(2, '0')}s`;
};

export const openSetUpTechKey = 'openSetUpTech';
export const openAiSignalKey = 'openAiSignal';
export const openCustomColumnKey = 'openCustomColumn';
export const openAskAiKey = 'openAskAi';
export const openEditProfileKey = 'oepnEditProfile';
export const openRevenueKey = 'openRevenue';

export const getLatestStartDateForFiltersWithTimezone = (userTimezone?: string) => {
  if (userTimezone && isValidTimezoneDayjs(userTimezone)) {
    const nowTz = dayjs().tz(userTimezone);
    const startOfWeekTz = nowTz.subtract(nowTz.day(), 'day').startOf('day');
    const sevenDaysBeforeStartOfWeek = new Date(
      startOfWeekTz.subtract(7, 'day').startOf('day').format(),
    );
    return convertDateToFormattedString(`${sevenDaysBeforeStartOfWeek}`);
  }

  // Fallback (original logic)
  return convertDateToFormattedString(
    `${dayjs(convertToDayStart(addDays(startOfWeek(new Date(), { weekStartsOn: 0 }), -7)))}`,
  );
};

export const getLatestEndDateForFilterssWithTimezone = (userTimezone?: string) => {
  if (userTimezone && isValidTimezoneDayjs(userTimezone)) {
    const endOfTodayTz = new Date(dayjs().tz(userTimezone).endOf('day').format());
    return convertDateToFormattedString(`${endOfTodayTz}`);
  }

  // Fallback (original logic)
  return convertDateToFormattedString(`${dayjs(convertToDayEnd(new Date()))}`);
};

// Email domains array - includes common email providers and temporary/disposable email services
// Note: yopmail.com is included for testing purposes and should be removed before production
export const excludeEmailDomainsForSelfSignup = [
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'yahoo.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'pm.me',
  'tutanota.com',
  'tutamail.com',
  'yandex.com',
  'yandex.ru',
  'gmx.com',
  'mail.com',
  'web.de',
  'qq.com',
  '163.com',
  '126.com',
  'rediffmail.com',
  'naver.com',
  'daum.net',
  'zoho.com',
  'mail.zoho.com',
  'yopmail.com', // TODO: Remove before production - kept for testing functionality
  'mailinator.com',
  'guerrillamail.com',
  '10minutemail.com',
  'tempmail.com',
  'temp-mail.org',
  'getnada.com',
  'sharklasers.com',
  'throwawaymail.com',
];
